<ion-header>
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-text-uppercase">
      {{ modalTitle }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  @if (modalMessage) {
    <div class="ion-text-center ion-margin-bottom">
      <ion-label class="fs-pt-14">
        {{ modalMessage }}
      </ion-label>
    </div>
  }

  @if (route) {
    <ion-button
      expand="block"
      color="primary"
      class="ion-margin-top ion-text-uppercase"
      (click)="open()">
      Apri
    </ion-button>
  }

  <ion-button
    expand="block"
    color="danger"
    class="ion-margin-top ion-text-uppercase"
    size="large"
    (click)="close()">
    Chiudi
  </ion-button>

</ion-content>
